import { render, staticRenderFns } from "./FootType.vue?vue&type=template&id=30fdfe07&scoped=true&"
import script from "./FootType.vue?vue&type=script&lang=js&"
export * from "./FootType.vue?vue&type=script&lang=js&"
import style0 from "./FootType.vue?vue&type=style&index=0&id=30fdfe07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fdfe07",
  null
  
)

export default component.exports